import React, { Component, Fragment } from 'react';
import DEFINE, {PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import {PageListComponent, HeaderListComponent, } from "../../common/component/Index";
import Hotel from './../../../../models/Hotel';
import { Icon, Rate, Button } from 'antd';
import TourList from './TourList';
import moment from 'moment'
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class Tours extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: {
                pageSize: this.props.tourState.pageSize,
                pageIndex: this.props.tourState.pageIndex,
            },
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TOUR);
        this.props.getListTours(this.state.params);
    }

    render() {
        const { t } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, tours, filters, order, isFetchingDownload } = this.props.tourState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'tours'}
                        titleHeader={t('navigation.tours')}
                        componentRight={
                            <Fragment>
                                <Button className='btn btn-primary mr-3' disabled={isFetchingDownload} style={{top: -13}}
                                    onClick={this.onClickDownloadExcel}>
                                    <Icon type={isFetchingDownload ? 'loading' : 'export'} className="mr-1" />{t(`item.voucher.exportFileExcel`)}
                                </Button>
                                {
                                    permisionActions && permisionActions.allowCreate &&
                                    <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                        <Link to={PATHS.TOUR.CREATE.path}
                                            className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                    </Ripple>
                                }
                            </Fragment>
                        }
                    />
                    <TourList loading={isFetching}
                        permisions={permisionActions}
                        tours={tours}
                        pagination={pagination}
                        onChange={this.onTableChange}
                        onDelete={this.onDeleteTour}
                        cloneTour={this.cloneTour}
                        />
                </PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let curfilters = this.state.filters;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'status');
                    curfilters = Func.removeElementObject(curfilters, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { curfilters = Func.removeElementObject(curfilters, 'IsLocked') }
                    if (filters.status[0] !== 999) { curfilters = Func.removeElementObject(curfilters, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            params: newFilters
        });
        this.props.getListTours(newFilters);
    };

    onDeleteTour = (tourItem) => {
        this.props.deleteTour(tourItem, this.state.params)
    }

    cloneTour = (id, lengthOfStay, isCopyTourTickets) => {
        this.props.cloneTour(id, lengthOfStay, isCopyTourTickets, this.state.params)
    }

    onChangeLanguage = (language) => {
        this.props.getListTours(this.state.filters)
    }

    onClickDownloadExcel = ()=>{
        const filters = this.state.params || {};
        this.props.exportExcel(filters);
    }

}
